// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"9725faa5","425":"bc66332a","510":"e41cab5f","532":"414d80e7","633":"a26be9b3","634":"4b07b988","922":"44be66b7","937":"063d20af","972":"b338286e"}[chunkId] + ".chunk.js";
};